var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSystemActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Ip_Phone"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ip_Phone",
    clipPath: "url(#clip-Ip_Phone)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone_System_active",
    transform: "translate(-19.001 -18.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone_System",
    "data-name": "Phone System",
    transform: "translate(21.002 22.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M20812.787,13767.508h-16.744a.977.977,0,0,1-.8-.419.063.063,0,0,0-.027-.023s0,0,0-.008a.018.018,0,0,1,0-.009,1,1,0,0,1-.16-.547v-19.544a1.006,1.006,0,0,1,.285-.709.973.973,0,0,1,.705-.291h16.748a1,1,0,0,1,.8.412.051.051,0,0,0,0,.018l.008.006h0v.008h0v.006h0a.957.957,0,0,1,.156.55v19.544a1,1,0,0,1-.979,1.006Zm-5.742-6.723h0v2.682h2.711v-2.682Zm-4,0h0v2.682h2.684v-2.682Zm-3.984,0h0v2.682h2.678v-2.682Zm7.982-4.057h0v2.687h2.711v-2.714Zm-4,0h0v2.687h2.684v-2.714Zm-3.984,0h0v2.687h2.678v-2.714Zm7.982-4.059h0v2.688h2.711v-2.688Zm-4,0h0v2.688h2.684v-2.688Zm-3.984,0h0v2.688h2.678v-2.688Z",
    transform: "translate(-20787.766 -13745.902)",
    fill: "#2e78d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Op_component_2",
    "data-name": "Op component 2",
    d: "M412.51,1129.6h1.407a1.2,1.2,0,0,0,.794-.292.949.949,0,0,0,.329-.708h0v-19.668a.906.906,0,0,0-.179-.535c0-.005-.01-.014-.014-.019a.089.089,0,0,0-.02-.025,1.167,1.167,0,0,0-.908-.417h-3.793a1.065,1.065,0,0,0-1.12,1V1128.6h0a.916.916,0,0,0,.179.542.074.074,0,0,1,.013.017c.007.011.016.017.02.026a1.164,1.164,0,0,0,.908.416h2.364",
    transform: "translate(-409.005 -1107.935)",
    fill: "#2e78d5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4545",
    "data-name": "Path 4545",
    d: "M4,0",
    transform: "translate(9.5 16.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSystemActive);
export default __webpack_public_path__ + "static/media/Phone_System_active.5b5dde4331493b2efa42729e9b15be81.svg";
export { ForwardRef as ReactComponent };